export enum KPASStatus {
  /** 有効 */
  Active = 'active',

  /** 削除済 */
  Deleted = 'deleted',

  /** 仮登録 */
  Interim = 'interim',
}

export enum KPASAppErrStatus {
  /**
   * 該当無し
   * * 照合できた利用者が存在しない
   */
  NoPerson = 'noPerson',

  /**
   * 複数検知
   * * 照合できた利用者が一意ではない
   */
  MmultiMatch = 'multiMatch',
}



// WEBPACK FOOTER //
// ./src/app/feature/face-detection-modal/kpas/kpas.enum.ts